import * as React from 'react';

import {CheckboxGroup} from 'shells/checkbox/checkbox-group';

import {ComparisonFieldsCheckboxButton} from './comparison-fields-checkbox-button';
import {SUBJECT, PREVIEW_TEXT, CONTENT} from './comparison-fields-select-modal';

type Props = {
    fieldsToCompare: string[];
    setFieldsToCompare: (arg1: string[]) => void;
};

export function ComparisonFieldsCheckboxGroup(props: Props) {
    return (
        <CheckboxGroup
            name='checkboxbuttons'
            selectedValues={props.fieldsToCompare}
            onChange={(newVal) => props.setFieldsToCompare(newVal)}
        >
            <ComparisonFieldsCheckboxButton value={SUBJECT} label='Subject lines' />
            <ComparisonFieldsCheckboxButton value={PREVIEW_TEXT} label='Preview text' />
            <ComparisonFieldsCheckboxButton value={CONTENT} label='Message content' />
        </CheckboxGroup>
    );
}
